module.exports = (Promise.resolve(__parcel__require__("./" + "Native.784c1e4d.7f77bce6.js"))).then(() => parcelRequire('5nLRG'));